module.exports = __webpack_public_path__ + "img/aq.85bf0f99.svg";